export default "__VITE_ASSET__CNadZSC1__"